/**
 * Fire-once tracker for analytics events that must emit at most once per map session.
 * All tracked keys share the same lifetime: mark on first fire, clear together on full unmount.
 */
export interface OnceTracker {
  /** True if this key has already been fired this session. */
  fired(key: string): boolean;
  /** Mark key as fired. */
  markFired(key: string): void;
  /** Clear all keys (real map exit — room/cityhall soft-unmount must not call this). */
  reset(): void;
}

export function createOnceTracker(): OnceTracker {
  const keys = new Set<string>();
  return {
    fired(key: string): boolean {
      return keys.has(key);
    },
    markFired(key: string): void {
      keys.add(key);
    },
    reset(): void {
      keys.clear();
    },
  };
}

/** Stable keys for map load-stage PostHog events. */
export const MAP_ANALYTICS_KEYS = {
  pixiInit: 'map_pixi_initialized',
  islandsRendered: 'map_islands_rendered',
  objectsRendered: 'map_objects_rendered',
  fullyLoaded: 'map_fully_loaded',
} as const;
